import React from 'react';
import { connect } from 'react-redux';
import LineChartContainer from 'components/pages/stats/totaloccupancy/linechartcontainer';
import { getNodeSeriesStats, getParams } from 'actions/stats';

export class TotalOccupancy extends React.Component {

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentNode.id) {
            let params = getParams(nextProps);
            this.props.dispatch(getNodeSeriesStats(params));
        }
    }

    render() {
        var showPeak = true;
        if ((this.props.querySettings.tag == "Efficiency" && this.props.currentNode.type != "meeting_room") ||
            (this.props.querySettings.tag == "Occupancy" && this.props.currentNode.type == "meeting_room")) {
            showPeak = false;
        }
        return (
            <LineChartContainer tag={this.props.querySettings.tag} showPeak={showPeak}/>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(null, mapDispatchToProps)(TotalOccupancy);


// WEBPACK FOOTER //
// ./src/components/pages/stats/totaloccupancy/index.jsx